module.exports = __webpack_public_path__ + "img/uz.d68b06bd.svg";